import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import DashboardPage from '../pages/DashboardPage';
import LeadsPage from '../pages/LeadsPage';
import WorkOrdersPage from '../pages/WorkOrdersPage';
import ClientsPage from '../pages/ClientsPage';
import EmployeesPage from '../pages/EmployeesPage';
import SettingsPage from '../pages/SettingsPage';

const CRMLayout: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('dashboard');

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      window.location.href = '/login';
    }
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardPage />;
      case 'leads':
        return <LeadsPage />;
      case 'workorders':
        return <WorkOrdersPage />;
      case 'clients':
        return <ClientsPage />;
      case 'employees':
        return <EmployeesPage />;
      case 'settings':
        return <SettingsPage />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="main-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default CRMLayout;